// extracted by mini-css-extract-plugin
export default {"Doc":"Doc_Doc__-moyB"};